import React, { useEffect } from "react";
import { SourceDto, MonsterDto } from "../../../Types/ApiTypes";
import { getAllSources, getAllMonsters } from "../../../Utils/LocalApi";
import MonsterTableComponent from "./MonsterTableComponent";
// import { useTranslation } from "react-i18next";
// import i18n from "../../../i18n";

const MonsterListComponent = ()=>{
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const { t } = useTranslation();

    const [allMonsters, setAllMonsters] = React.useState<MonsterDto[]>([]);
    useEffect(() => {
        getAllMonsters().then((value) => {
            let newMonsters = [] as MonsterDto[];
            value.forEach((element: MonsterDto) => {
                newMonsters.push(element);
                setAllMonsters([...newMonsters]);
            });
        });
    },[]);

    const [allSources, setAllSources] = React.useState<SourceDto[]>([]);
    useEffect(() => {
        getAllSources().then((value) => {
            setAllSources(value);
        });
    },[]);
    
    
    return (
        <div className="">
            <MonsterTableComponent
                allMonsters = {allMonsters}
                allSources = {allSources}
                setAllMonsters = {setAllMonsters}
            ></MonsterTableComponent>
        </div>
    )
}
export default MonsterListComponent;
